import { inject, Injectable } from '@angular/core';
import { GLOBAL_MESSAGE_KEY, GLOBAL_TOAST_KEY } from '@core/constants';
import { ToastMessageOptions, MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private readonly messageService = inject(MessageService);

  public showSuccess(title: string, message: string): void {
    this.messageService.add({
      key: GLOBAL_TOAST_KEY,
      severity: 'success',
      summary: title,
      detail: message,
      life: 5000,
    });
  }

  public showError(title: string, message: string): void {
    this.messageService.add({
      key: GLOBAL_TOAST_KEY,
      severity: 'error',
      summary: title,
      detail: message,
      life: 5000,
    });
  }

  public showMessage(title: string, message: string): void {
    this.messageService.add({
      key: GLOBAL_MESSAGE_KEY,
      severity: 'info',
      summary: title,
      detail: message,
    });
  }
}
